import BaseModel from './BaseModel';
import Reference from './Reference';
import ReviewMember from './ReviewMember';
import ReviewCriteria from './ReviewCriteria';
import moment from 'moment';
import {
  ScreeningOutcomeResolution,
  InclusionAssessment,
} from '@/enums';

export default class FullTextReviewOutcome extends BaseModel {
  constructor(data = {}) {
    super(FullTextReviewOutcome, data);
    this.id = data.id;
    this.optimisticId = data.optimisticId;
    this.reference = data.reference
      ? new Reference(data.reference)
      : null;
    this.outcome = data.outcome;
    this.resolution = data.resolution;
    this.resolvedBy = data.resolvedBy
      ? new ReviewMember(data.resolvedBy)
      : null;
    this.reasonReviewCriteria = data.reasonReviewCriteria
      ? new ReviewCriteria(data.reasonReviewCriteria)
      : null;
    this.createdAt = moment(data.createdAt);
    this.archived = data.archived;
    this.preventRestore = data.preventRestore;
  }

  creationData() {
    return {
      id: this.id,
      reference: this.reference.id,
      outcome: this.outcome,
      resolution: this.resolution,
      reasonReviewCriteria: this.reasonReviewCriteria
        ? this.reasonReviewCriteria.id
        : null,
    };
  }

  isConsensus() {
    return (
      this.resolution === ScreeningOutcomeResolution.UNANIMOUS_VOTE
    );
  }

  isManualUpdate() {
    return (
      this.resolution === ScreeningOutcomeResolution.UPDATED_OUTCOME
    );
  }

  isPreScreened() {
    return (
      this.resolution === ScreeningOutcomeResolution.PRE_SCREENED
    );
  }

  isConflictResolution() {
    return (
      this.resolution ===
      ScreeningOutcomeResolution.CONFLICT_RESOLUTION
    );
  }

  isIncluded() {
    return this.outcome === InclusionAssessment.INCLUDE;
  }

  isExcluded() {
    return this.outcome === InclusionAssessment.EXCLUDE;
  }

  isOptimistic() {
    return !!this.optimisticId;
  }
}
